export const PORTFOLIO_GANTT_CONFIG = {
    name            : 'Gantt',
    menuName        : 'Gantt',
    icon            : 'i5-gantchart2',
    // iconLight       : 'i5-gantt-light',
    image           : 'gantt',
    iconSvg         : 'isvg-view-gantt',
    url             : 'gantt',
    stringId        : 'gantt',
    proOnly         : true,
    description     : 'Plan your work and manage tasks, subprojects and dependencies.'
}
